var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        class: [
            _vm.$style.container,
            _setup.isApp ? _vm.$style.inApp : ''
        ]
    }, [
        _c('img', {
            class: _vm.$style.logo,
            attrs: {
                "src": require("@/assets/img/logo.png"),
                "alt": ""
            }
        }),
        _c('div', {
            class: _vm.$style.content
        }, [
            _c('h5', {
                class: _vm.$style.title
            }, [
                _vm._v("Información personal")
            ]),
            _c('div', {
                class: _vm.$style.userInfo
            }, [
                _c('p', [
                    _vm._v("Nombre: " + _vm._s(_setup.userStore.name))
                ]),
                _c('p', [
                    _vm._v("Número de telefónico: " + _vm._s(_setup.userStore.phone))
                ])
            ])
        ]),
        _setup.repayList.length === 1 ? _c('div', _vm._l(_setup.repayList, function(item) {
            return _c('div', {
                key: item.borrowContractId,
                staticClass: "contract-detail"
            }, [
                _c('p', {
                    staticClass: "contract-number"
                }, [
                    _vm._v("Contrato: " + _vm._s(item.borrowContractId))
                ]),
                _c('p', {
                    staticClass: "text"
                }, [
                    _vm._v("Importe pendiente de pago")
                ]),
                _c('p', {
                    staticClass: "money"
                }, [
                    _vm._v("$" + _vm._s(_setup.formatAmount(item.allOutstandingBalance)))
                ]),
                _c('p', {
                    staticClass: "date"
                }, [
                    _vm._v(" Día de pago: " + _vm._s(_setup.formatDate(item.planDate)) + " "),
                    item.delayedFlag ? _c('span', {
                        staticStyle: {
                            "color": "#f00",
                            "margin-left": "8px"
                        }
                    }, [
                        _vm._v(" " + _vm._s(item.delayedDays) + " días de retraso ")
                    ]) : _vm._e()
                ]),
                _c('van-button', {
                    staticClass: "btn",
                    attrs: {
                        "block": ""
                    },
                    on: {
                        "click": function($event) {
                            return _setup.goRepay(item.formKey);
                        }
                    }
                }, [
                    _vm._v("Reembolsar ahora")
                ]),
                _c('img', {
                    attrs: {
                        "src": require("@/assets/img/repay/tab-bg.png"),
                        "alt": ""
                    }
                })
            ], 1);
        }), 0) : _vm._e(),
        _setup.repayList.length > 1 ? _c('van-tabs', {
            attrs: {
                "color": "#4fc684",
                "background": "transparent",
                "title-active-color": "#4fc684",
                "title-inactive-color": ""
            },
            model: {
                value: _setup.active,
                callback: function callback($$v) {
                    _setup.active = $$v;
                },
                expression: "active"
            }
        }, _vm._l(_setup.repayList, function(item, index) {
            return _c('van-tab', {
                key: item.borrowContractId,
                attrs: {
                    "title": 'Contrato ' + (index + 1)
                }
            }, [
                _c('div', {
                    staticClass: "contract-detail"
                }, [
                    _c('p', {
                        staticClass: "contract-number"
                    }, [
                        _vm._v("Contrato: " + _vm._s(item.borrowContractId))
                    ]),
                    _c('p', {
                        staticClass: "text"
                    }, [
                        _vm._v("Importe pendiente de pago")
                    ]),
                    _c('p', {
                        staticClass: "money"
                    }, [
                        _vm._v("$" + _vm._s(_setup.formatAmount(item.allOutstandingBalance)))
                    ]),
                    _c('p', {
                        staticClass: "date"
                    }, [
                        _vm._v(" Día de pago: " + _vm._s(_setup.formatDate(item.planDate)) + " "),
                        item.delayedFlag ? _c('span', {
                            staticStyle: {
                                "color": "#f00",
                                "margin-left": "8px"
                            }
                        }, [
                            _vm._v(" " + _vm._s(item.delayedDays) + " días de retraso ")
                        ]) : _vm._e()
                    ]),
                    _c('van-button', {
                        staticClass: "btn",
                        attrs: {
                            "block": ""
                        },
                        on: {
                            "click": function($event) {
                                return _setup.goRepay(item.formKey);
                            }
                        }
                    }, [
                        _vm._v("Reembolsar ahora")
                    ]),
                    _c('img', {
                        attrs: {
                            "src": require("@/assets/img/repay/tab-bg.png"),
                            "alt": ""
                        }
                    })
                ], 1)
            ]);
        }), 1) : _vm._e()
    ], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };
